var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"x-button x-button-submit",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }